/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_c_friend_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FRIEND (F, R, I, E, N, D) has no common six-letter anagram, but it's rich in shorter words: FINER, DINER, FIRED, FIEND, and FRIED all use five of its six letters. Drop to four letters and FIND, FINE, RIDE, and DINE appear too.`)
};

const es_wu_c_friend_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FRIEND (F, R, I, E, N, D) no tiene un anagrama común de seis letras, pero es rica en palabras más cortas: FINER, DINER, FIRED, FIEND y FRIED usan cinco de sus seis letras. Si bajas a cuatro letras, también aparecen FIND, FINE, RIDE y DINE.`)
};

const de_wu_c_friend_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FRIEND (F, R, I, E, N, D) hat kein gebräuchliches sechsstelliges Anagramm, ist aber reich an kürzeren Wörtern: FINER, DINER, FIRED, FIEND und FRIED nutzen jeweils fünf der sechs Buchstaben. Gehst du auf vier Buchstaben herunter, tauchen außerdem FIND, FINE, RIDE und DINE auf.`)
};

const nl_wu_c_friend_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FRIEND (F, R, I, E, N, D) heeft geen gangbaar anagram van zes letters, maar is rijk aan kortere woorden: FINER, DINER, FIRED, FIEND en FRIED gebruiken allemaal vijf van de zes letters. Ga naar vier letters en ook FIND, FINE, RIDE en DINE verschijnen.`)
};

const fr_wu_c_friend_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FRIEND (F, R, I, E, N, D) n'a pas d'anagramme courante à six lettres, mais il regorge de mots plus courts : FINER, DINER, FIRED, FIEND et FRIED utilisent tous cinq de ses six lettres. En passant à quatre lettres, FIND, FINE, RIDE et DINE apparaissent également.`)
};

const it_wu_c_friend_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FRIEND (F, R, I, E, N, D) non ha un anagramma comune di sei lettere, ma è ricca di parole più corte: FINER, DINER, FIRED, FIEND e FRIED usano tutte cinque delle sue sei lettere. Scendendo a quattro lettere compaiono anche FIND, FINE, RIDE e DINE.`)
};

const pt_br2_wu_c_friend_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FRIEND (F, R, I, E, N, D) não tem um anagrama comum de seis letras, mas é rica em palavras mais curtas: FINER, DINER, FIRED, FIEND e FRIED usam todas cinco das seis letras. Reduzindo para quatro letras, aparecem também FIND, FINE, RIDE e DINE.`)
};

const pt_wu_c_friend_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FRIEND (F, R, I, E, N, D) não tem nenhum anagrama comum de seis letras, mas é rica em palavras mais curtas: FINER, DINER, FIRED, FIEND e FRIED usam todas cinco das suas seis letras. Descendo para quatro letras, surgem também FIND, FINE, RIDE e DINE.`)
};

const ja_wu_c_friend_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FRIEND（F, R, I, E, N, D）には一般的な6文字のアナグラムはありませんが、短い単語は豊富です。FINER、DINER、FIRED、FIEND、FRIEDはすべて6文字のうち5文字を使っています。4文字まで減らすと、FIND、FINE、RIDE、DINEも現れます。`)
};

const zh_wu_c_friend_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FRIEND（F、R、I、E、N、D）没有常见的六字母易位构词，但短单词很丰富：FINER、DINER、FIRED、FIEND 和 FRIED 都用到了六个字母中的五个。缩小到四个字母，还会出现 FIND、FINE、RIDE 和 DINE。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_c_friend_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_c_friend_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_c_friend_faq1_a", locale)
	if (locale === "en") return en_wu_c_friend_faq1_a(inputs)
	if (locale === "es") return es_wu_c_friend_faq1_a(inputs)
	if (locale === "de") return de_wu_c_friend_faq1_a(inputs)
	if (locale === "nl") return nl_wu_c_friend_faq1_a(inputs)
	if (locale === "fr") return fr_wu_c_friend_faq1_a(inputs)
	if (locale === "it") return it_wu_c_friend_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_wu_c_friend_faq1_a(inputs)
	if (locale === "pt") return pt_wu_c_friend_faq1_a(inputs)
	if (locale === "ja") return ja_wu_c_friend_faq1_a(inputs)
	return zh_wu_c_friend_faq1_a(inputs)
};